import React from "react";
import { Image } from "semantic-ui-react";
import PrintBlueIcon from "../../assets/images/print_blue.png";
import CheckIcon from "../../assets/images/check_36x36.png";
import CompIcon from "../../assets/images/report_icon_48x48_selected.png";
import ReportIcon from "../../assets/images/report_icon_48x48_unselected.png";

export const getQuickTips = (view) => {
  const lowerCaseView = view.toLowerCase();
  const lowerCaseNoSpaceView = lowerCaseView.replace(/ /g, "");

  if (
    lowerCaseView.indexOf("notauthorized") > 0 ||
    lowerCaseView.indexOf("not authorized") > 0
  )
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        You are not authorized to perform this action
      </span>,
    ];
  else if (lowerCaseView.indexOf("unavailable") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        This search is currently unavailable
      </span>,
    ];

  if (lowerCaseNoSpaceView.indexOf("addressanddob") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
                Choose a tab below to search with different input criteria
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Search by first, last name and state.
      </li>,
      <li key="qt_2">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Narrow results using a city, address or date of birth.
      </li>,
      <li key="qt_3">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        If searching with an apartment number, include that in the street address bar.
      </li>,
    ];
  else if (
    lowerCaseNoSpaceView.indexOf("byname") > 0 ||
    lowerCaseNoSpaceView.indexOf("byofficername") > 0
  )
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Choose a tab below to search with different input criteria!
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Search by First, Last Name and State
      </li>,
      <li key="qt_2">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Narrow results by including a City
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("byaddress") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Choose a tab below to search with different input criteria!
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Search using street address and state.
      </li>,
      <li key="qt_2">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Narrow results using a city or zip code.
      </li>,
      <li key="qt_3">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        If searching with an apartment number, include that in the street address bar.
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("byssn") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Choose a tab below to search with different input criteria!
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        For best results - search using a full SSN.
      </li>,
      <li key="qt_2">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Partial SSNs cannot be searched.
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("byphone") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Enter a 10-digit phone number! , 
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        {"( ) or -  are not required"}
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("byemailaddress") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Choose a tab below to search with different input criteria
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Search by full Email Address
      </li>,
      <li key="qt_2">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Only search for one email address at a time
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("bybusinessname") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Search by Business Name
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Narrow results by including a State or Zip Code
      </li>,
    ];
  else if (lowerCaseNoSpaceView.indexOf("bylicensenumber") > 0)
    return [
      <span
        className="primaryTip content font_bold medium_font"
        style={{ display: "block" }}
      >
        Choose a tab below to search with different input criteria
      </span>,
      <li key="qt_1">
        <span
          className={"ui-icon ui-icon-check"}
          style={{ display: "inline", float: "left" }}
        />
        Search by License Number
      </li>,
    ];

  switch (lowerCaseNoSpaceView) {
    case "ssnverification_ssnverification_byssn":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Search by full SSN
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Partial SSNs cannot be searched
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Provides State Issued, Years Issued and Status of the SSN entered
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          If an SSN was issued after June 25, 2011 it cannot be verified as having been issued or not
        </li>,
      ];
    case "vehicles_vehicledppa_bylicenseplate":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Choose a tab below to search with different input criteria
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Search by License Plate and State
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Partial License Plates cannot be searched
        </li>,
      ];
    case "vehicles_vehicledppa_byvin":
    case "vehicles_vehiclenon-dppa_byvin":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Choose a tab below to search with different input criteria
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Search by full VIN (17 characters)
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Partial VINs cannot be searched
        </li>,
      ];
    case "vehicles_driverhistory_vehicleoffline":
    case "driverhistory_driverhistory_vehicleoffline":
    case "criminal_criminalcourtoffline_offlinesearch":
    case "civil_civilcourtoffline_offlinesearch":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Enter all required fields. 
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Offline requests cannot be canceled once submitted.
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Please ensure all information is correct prior to submitting your request. 
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Turnaround times vary by state.
        </li>,
      ];
    case "watercrafts_watercraft_byhull":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Choose a tab below to search with different input criteria
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Search by Hull ID
        </li>,
      ];
    case "criminal_instantcriminal_bynameanddob":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Search by First, Last Name and full Date of Birth
        </span>,
      ];
    case "corporation/business_businessbyein_byein":
    case "corporation/business_business_byein":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Choose a tab below to search with different input criteria
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Search by EIN (Employer Identification Number)
        </li>,
      ];
    case "residential_multiplenumbers_byphone":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Enter a 10-digit phone number! 
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          {"( ) or -  are not required"}
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          You can enter up to 10 numbers to get results
        </li>,
      ];
    case "person_liveenhanced":
    case "person_personplatinum":
    case "person_persongold":
    case "person_person":
    case "person_basic":
    case "person_financialheader":
    case "person_live":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Click on &#39;Get More Details&#39; button to see subject&#39;s summary and view report options
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Unmask full SSN and full DOB if available
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          No additional cost 
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          <Image inline src={CheckIcon} />
          {"indicates most current address"}
        </li>,
      ];
    case "relationships_neighbors":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Click on &#39;View Neighbors&#39; button to see subject&#39;s neighbors at each address
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          No additional cost
        </li>,
      ];
    case "relationships_relatives":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Click on &#39;View Relatives&#39; button to see subject&#39;s relatives
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          No additional cost
        </li>,
      ];
    case "civil_businessbljs":
    case "businessblj_businessblj":
    case "vehicles_vehicledppa":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Check off boxes next to results to get multiple reports
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Check off &#39;Select All&#39; box to select/deselect all results
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on &#39;Get Report&#39; button to run reports
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on 
          <Image inline src={ReportIcon} />
          {"to view a single report"}
        </li>,
        <li key="qt_4">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          No additional cost
        </li>,
      ];
    case "vehicles_vehiclenon-dppa":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Review your results below{" "}
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click the <Image inline src={PrintBlueIcon} /> to print your results
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Use the left search bar to modify or start a new search
        </li>,
      ];
    case "property_property":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Click on 
          <Image inline src={ReportIcon} />
          {"to run a Basic Property Report"}
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Basic Property Report includes owner name, sales history, structural details and more
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on 
          <Image inline src={CompIcon} />
          {"to run a Comprehensive Property Report"}
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Comprehensive Property Report includes items in the Basic Report along with detailed neighborhood sales comparables
        </li>,
      ];
    case "criminal_instantcriminal":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Check off boxes next to results to get multiple reports
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Check off &#39;Select All&#39; box to select/deselect all results
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on &#39;Get Report&#39; button to run reports
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Results include Physical Description, Address, Offense Details, Arresting Agency, picture (if available) and more
        </li>,
      ];
    case "civil_personbljs":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Check off boxes next to results to get multiple reports
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Check off &#39;Select All&#39; box to select/deselect all results
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on &#39;Get Report&#39; button to run reports
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Results include Address, Filing Type, Filing Description, Court Name, Disposition and more
        </li>,
      ];
    case "corporation/business_corporation/business":
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
          Check off boxes next to results to get multiple reports
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Check off &#39;Select All&#39; box to select/deselect all results
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on &#39;Get Report&#39; button to run reports
        </li>,
        <li key="qt_3">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Click on 
          <Image inline src={ReportIcon} />
          {"to view a single report"}
        </li>,
        <li key="qt_4">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          {`"No additional cost"`}
        </li>,
      ];
    default:
      if (lowerCaseView.indexOf("_by") > 0)
        return [
          `Choose a tab below to search with different input criteria!","Search ${lowerCaseView.substring(
            lowerCaseView.indexOf("_by") + 1
          )}`,
        ];
      return [
        <span
          className="primaryTip content font_bold medium_font"
          style={{ display: "block" }}
        >
           Review your results below 
        </span>,
        <li key="qt_1">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          <Image inline src={PrintBlueIcon} />
          {"to print your results"} 
        </li>,
        <li key="qt_2">
          <span
            className={"ui-icon ui-icon-check"}
            style={{ display: "inline", float: "left" }}
          />
          Use the left search bar to modify or start a new search
        </li>,
      ];
  }
};

export default getQuickTips;



// WEBPACK FOOTER //
// ./src/components/forms/QuickTips.js